/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toggle_ColumnsInputs */

const en_table_toggle_columns = /** @type {(inputs: Table_Toggle_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

const es_table_toggle_columns = /** @type {(inputs: Table_Toggle_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar u ocultar columnas`)
};

/**
* | output |
* | --- |
* | "Toggle columns" |
*
* @param {Table_Toggle_ColumnsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_toggle_columns = /** @type {((inputs?: Table_Toggle_ColumnsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toggle_ColumnsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_toggle_columns(inputs)
	return es_table_toggle_columns(inputs)
});